import { Box, Divider, Typography } from '@mui/material'

import { Fragment, useRef } from 'react'

import { createId } from '@services/utils'
import { AWS, AZURE } from "@features/hooks/LandingZones"

export const Group = (props) => {
    const items = useRef({
        [AZURE]: [
            {name: 'LzOwner', owner: '[IASP] Landing Zone Owner / Contributor', members: '[IASP] Landing Zone Owner / Contributor', info: ', meaning that those identity have the full responsibility on the Landing Zone' },
            {name: 'LzContributor', owner: '[IASP] Landing Zone Contributor', members: '[IASP] Landing Zone Contributor', info: ' on the Landing Zone' },
            {name: 'Reader', owner: '[IASP] Landing Zone Reader', members: '[IASP] Landing Zone Reader', info: ' on the Landing Zone' }
        ],
        [AWS]: [
            {name: 'Owner', members: 'WL-Owner', info: ', meaning they have full responsibility for the Workload Account (manage AWS services, create and manage IAM policies and roles, and read all resources)' },
            {name: 'Contributor', members: 'WL-Contributor', info: ', meaning they can manage AWS services and read resources, but cannot create or manage IAM roles and policies' },
            {name: 'Reader', members: 'WL-Reader', info: ', meaning they have read-only access to all resources in the Workload Account' },
            {name: 'Jump', members: 'WL-Jump', info: ', used for temporary access to the Workload Account via a jump mechanism, without additional privileges' }
        ]
    })

    return (
        <Fragment>
            {props.provider && items.current[props.provider].map(item => {
                const id = createId()
                return (
                    <Box key={id}>
                        <Box sx={{paddingLeft: '16px'}}>
                            <Typography variant={'h5'}>
                                {(props.provider && props.provider === AZURE) ? `AZR-IASP-LZ-${props.name}-${item.name}` : `AWS-ALZP-WL-${props.name}-${item.name}`}
                            </Typography>
                            <Box sx={{paddingLeft: '16px'}}>
                                <Typography variant={'h6'} sx={{fontWeight: 400}}>
                                    Owners: <i>CAJ/CAL/AJ/AL@tdf/admin.hubtotal.net</i> that are responsible to grant privileges
                                </Typography>
                                <Typography variant={'h6'} sx={{fontWeight: 400}}>
                                    Members: <i>CAJ/CAL/AJ/AL@tdf/admin.hubtotal.net</i> that have <strong>{item.members} role</strong>{item.info}
                                </Typography>
                            </Box>
                        </Box>
                        <Divider sx={{mt: 1, mb: 1}} />
                    </Box>
                )
            })}
            {props.provider && props.provider === AZURE && (
                <Box>
                    <Box sx={{paddingLeft: '16px'}}>
                        <Typography variant={'h5'}>AZR-IASP-LZ-{props.name}-Notifications</Typography>
                        <Box sx={{paddingLeft: '16px'}}>
                            <Typography variant={'h6'} sx={{fontWeight: 400}}>
                                Owners: <i>CAJ/CAL/AJ/AL@tdf/admin.hubtotal.net</i> that can add or remove member who should receive email notifications
                            </Typography>
                            <Typography variant={'h6'} sx={{fontWeight: 400}}>
                                Members: <i>firstname.lastname@[external].totalenergies.com</i> that will receive email notification from Inox@Scale
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            )}
        </Fragment>
    )
}

export default Group